module.exports = __webpack_public_path__ + "static/sport/icon-2.f55f1bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport6/icon-2.png
// module id = 8sy4
// module chunks = 0